import {
  Globe, Smartphone, Layers, Plug, Code2, Database,
  Cloud, ShieldCheck, Rocket, Cpu, Zap, Package,
  Phone, Mail, ArrowRight, MessageCircle, ShoppingCart, Calendar,
} from "lucide-react";

// Doit rester en phase avec ICON_CHOICES côté backend
// (backend/services/theme_engines/default/fields.py) : le backend ne connaît
// que le NOM de l'icône (une clé de registre fermé, jamais un composant), la
// résolution en composant lucide-react ne se fait qu'ici, côté rendu.
export const ICON_COMPONENTS = {
  Globe, Smartphone, Layers, Plug, Code2, Database,
  Cloud, ShieldCheck, Rocket, Cpu, Zap, Package,
  Phone, Mail, ArrowRight, MessageCircle, ShoppingCart, Calendar,
};
